import { render } from "./SignaturePreview.vue?vue&type=template&id=1f686510"
import script from "./SignaturePreview.vue?vue&type=script&lang=js"
export * from "./SignaturePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__